export const fourPointTemplate = [
  {
    id: 'document_version',
    width: 150,
    header: 'generateReport.dataToResult.report.general.document_version',
  },
  {
    id: 'id_ensaio',
    width: 230,
    header: 'generateReport.dataToResult.report.test.four_point.id_ensaio',
  },
  {    
    id: 'id_hex',
    header: 'generateReport.dataToResult.report.general.id_hex',
  },
  {
    id: 'product',
    width: 120,
    header: 'product',
  },
  {
    id: 'product_version',
    width: 120,
    header: 'version',
  },
  {
    id: 'date_authorised',
    width: 100,
    header: 'generateReport.dataToResult.report.general.date_started',
  },
  {
    id: 'observacao_geral',
    width: 400,
    header: 'generateReport.dataToResult.report.general.remark',
  },
  {
    id: 'text_comentario',
    width: 400,
    header: 'generateReport.dataToResult.report.general.text_comentario',
  },
  {
    id: 'project',
    width: 230,
    header: 'generateReport.dataToResult.report.test.four_point.project',
  },
  {
    id: 'lot_id',
    width: 230,
    header: 'generateReport.dataToResult.report.test.four_point.lot_id',
  },
  {
    id: 'status',
    header: 'generateReport.dataToResult.report.test.four_point.status',
  },
  {
    id: 'planta_origem',
    header: 'generateReport.dataToResult.report.test.four_point.planta_origem',
  },
  {
    id: 'data_cadastro',
    width: 230,
    header: 'generateReport.dataToResult.report.test.four_point.data_cadastro',
  },
  {
    id: 'data_liberacao_resultado',
    width: 230,
    header:
      'generateReport.dataToResult.report.test.four_point.data_liberacao_resultado',
  },
  {
    id: 'id_numeric',
    header: 'generateReport.dataToResult.report.test.four_point.id_numeric',
  },
  {
    id: 'amostra_mes',
    header: 'generateReport.dataToResult.report.test.four_point.amostra_mes',
  },
  {
    id: 'desc_cliente',
    width: 230,
    header: 'generateReport.dataToResult.report.test.four_point.desc_cliente',
  },
  {
    id: 'descricao_mes',
    width: 420,
    header: 'generateReport.dataToResult.report.test.four_point.descricao_mes',
  },
  {
    id: 'firma_insp',
    width: 310,
    header: 'generateReport.dataToResult.report.test.four_point.firma_insp',
  },
  {
    id: 'pedido',
    header: 'generateReport.dataToResult.report.test.four_point.pedido',
  },
  {
    id: 'item',
    header: 'generateReport.dataToResult.report.test.four_point.item',
  },
  {
    id: 'corrida',
    header: 'generateReport.dataToResult.report.test.four_point.corrida',
  },
  {
    id: 'bitola',
    header: 'generateReport.dataToResult.report.test.four_point.bitola',
  },
  {
    id: 'control_lot',
    header: 'generateReport.dataToResult.report.test.four_point.control_lot',
  },
  {
    id: 'aco',
    header: 'generateReport.dataToResult.report.test.four_point.aco',
  },
  {
    id: 'etiqueta',
    header: 'generateReport.dataToResult.report.test.four_point.etiqueta',
  },
  {
    id: 'metodo_desengraxe',
    header:
      'generateReport.dataToResult.report.test.four_point.metodo_desengraxe',
  },
  {
    id: 'identificacao_cp',
    width: 230,
    header:
      'generateReport.dataToResult.report.test.four_point.identificacao_cp',
  },
  {
    id: 'data_entrada',
    width: 230,
    header: 'generateReport.dataToResult.report.test.four_point.data_entrada',
  },
  {
    id: 'data_saida',
    width: 230,
    header: 'generateReport.dataToResult.report.test.four_point.data_saida',
  },
  {
    id: 'solucao',
    header: 'generateReport.dataToResult.report.test.four_point.solucao',
  },
  {
    id: 'ph_antes_saturacao',
    header:
      'generateReport.dataToResult.report.test.four_point.ph_antes_saturacao',
  },
  {
    id: 'concentracao_h2s_inicial',
    header:
      'generateReport.dataToResult.report.test.four_point.concentracao_h2s_inicial',
  },
  {
    id: 'ph_final',
    header: 'generateReport.dataToResult.report.test.four_point.ph_final',
  },
  {
    id: 'concentracao_h2s_final',
    header:
      'generateReport.dataToResult.report.test.four_point.concentracao_h2s_final',
  },
  {
    id: 'le',
    header: 'generateReport.dataToResult.report.test.four_point.le',
  },
  {
    id: 'tensao',
    header: 'generateReport.dataToResult.report.test.four_point.tensao',
  },
  {
    id: 'observacao',
    header: 'generateReport.dataToResult.report.test.four_point.observacao',
  },
  {
    id: 'deslocamento',
    header: 'generateReport.dataToResult.report.test.four_point.deslocamento',
  },
  {
    id: 'resultado',
    header: 'generateReport.dataToResult.report.test.four_point.resultado',
  },
]
